// BodyContent.jsx
import Grid from "@mui/material/Grid";
import React, { useState } from "react";

import CompletedCalls from "../completedCalls";
import Indicators from "../Indicators";
import * as Styles from "./styles";
import WantToDoCard from "../wantToDoCard";

const BodyContent = () => {
  const [filtersIndicators, setFilterIndicator] = useState(null);

  return (
    <Styles.Section>
      {/* Primeira Linha: WantToDoCard */}
      {/* <Grid container spacing={4} style={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <WantToDoCard />
        </Grid>
      </Grid> */}

      {/* Segunda Linha: Indicators e CompletedCalls */}
      <Grid container spacing={{ xs: 4, sm: 4, md: 4, lg: 10 }}>
        <Grid item md={5} sm={12} xs={12}>
          <Indicators filter={filtersIndicators} />
        </Grid>
        <Grid item md={7} sm={12} xs={12}>
          <CompletedCalls
            onChangeFiltrosIndicadores={(item) => setFilterIndicator(item)}
          />
        </Grid>
      </Grid>
    </Styles.Section>
  );
};

export default BodyContent;
